// extracted by mini-css-extract-plugin
export default {"container":"mobile_container__sI1Mc","content":"mobile_content__WjV8-","navbarIcons":"mobile_navbarIcons__auboR","overflowHidden":"mobile_overflowHidden__hTaws"};